export const PACKAGE_VERSION = '2.6.0'
